import { TablePagination } from "@mui/material";
import { ChangeEventHandler } from "react";

type StyledTablePaginationProps = {
  count: number;
  rowsPerPage: number;
  page: number;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  handleChangeRowsPerPage:
    | ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>
    | undefined;
};

export default function StyledTablePagination({
  count,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
}: StyledTablePaginationProps) {
  return (
    <TablePagination
      component={"div"}
      rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
      colSpan={3}
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      // SelectProps={{
      //   inputProps: {
      //     "aria-label": "rows per page",
      //   },
      //   native: true,
      // }}
      style={{ display: "flex", justifyContent: "center" }}
      sx={{
        "& .MuiTablePagination-toolbar": {
          paddingRight: "0px",
          marginRight: "0px",
        },
        "& .MuiTablePagination-actions": {
          marginLeft: "0px",
        },
        "& .MuiTablePagination-selectLabel": {
          display: "none",
        },
      }}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  );
}
